import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { BestDay } from './logos/best-day.js';
import { CDF } from './logos/cdf.js';
import { Discover } from './logos/discover.js';
import { InField } from './logos/in-field.js';
import { InRobot } from './logos/in-robot.js';
import { Maintain } from './logos/maintain.js';
import { Remote } from './logos/remote.js';
import { Atlas } from './logos/atlas.js';

/**
 * ProductLogo
 * =============================================================================
 * Shows the Cognite logo with, or without type
 *
 * [Open docs »](https://cognitedata.github.io/cogs.js/?path=/docs/assets-logo--base)
 *
 * _Component maintained by: **Ronald Baars**_
 *
 * -----------------------------------------------------------------------------
 * Examples
 * -----------------------------------------------------------------------------
 * ```
 * <ProductLogo />
 * <ProductLogo type="Discover" />
 * <ProductLogo type="InField" inverted />
 * <ProductLogo type="InRobot" inverted size="80px" />
 * ```
 *
 * -----------------------------------------------------------------------------
 * Properties
 * -----------------------------------------------------------------------------
 * @param size    - The size of the logo as css value.
 * @param type    - Which logo to show.
 *
 * [Read the full documentation »](https://cognitedata.github.io/cogs.js/?path=/docs/assets-logo--base)
 */
var ProductLogo = function ProductLogo(_a) {
  var type = _a.type,
    otherProps = __rest(_a, ["type"]);
  switch (type) {
    case 'BestDay':
      return jsx(BestDay, Object.assign({}, otherProps));
    case 'CDF':
      return jsx(CDF, Object.assign({}, otherProps));
    case 'Discover':
      return jsx(Discover, Object.assign({}, otherProps));
    case 'InField':
      return jsx(InField, Object.assign({}, otherProps));
    case 'InRobot':
      return jsx(InRobot, Object.assign({}, otherProps));
    case 'Maintain':
      return jsx(Maintain, Object.assign({}, otherProps));
    case 'Remote':
      return jsx(Remote, Object.assign({}, otherProps));
    case 'Atlas':
      return jsx(Atlas, Object.assign({}, otherProps));
    default:
      return jsx(CDF, Object.assign({}, otherProps));
  }
};

export { ProductLogo };
